import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const deleteAdvancedSurvey = async ({ surveyId }) => {
  const token = localStorage.getItem("token");

  await axios.delete(`${__API_URL__}/api/survey/advanced-surveys/${surveyId}/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });
};

const useDeleteAdvancedSurveyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteAdvancedSurvey,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["advanced_surveys"],
      });
    },
  });
};

export default useDeleteAdvancedSurveyMutation;
